if (!customElements.get("circle-text")) {
	customElements.define(
		"circle-text",
		class CircleText extends HTMLElement {
			constructor() {
				super();
				this.strongs = [];
				this.svgElements = [];
				this.observer = null;
			}

			connectedCallback() {
				setTimeout(() => {
					this.init();
				}, 0);
			}

			init() {
				this.strongs = this.querySelectorAll("strong");
				if (this.strongs.length === 0) return;

				this.createSVGElements();
				this.setupScrollObserver();
			}

			createSVGElements() {
				this.strongs.forEach((strong, index) => {
					const svg = document.createElementNS(
						"http://www.w3.org/2000/svg",
						"svg"
					);
					const path = document.createElementNS(
						"http://www.w3.org/2000/svg",
						"path"
					);

					path.setAttribute("fill", "none");
					path.setAttribute("stroke", "rgb(var(--advanced-display-color))");
					path.setAttribute("stroke-width", "5");
					path.setAttribute("stroke-linecap", "butt");
					path.setAttribute("pathLength", "1");
					path.setAttribute("stroke-dasharray", "0 1");
					path.style.transition = "stroke-dasharray 1.2s ease-out";

					svg.appendChild(path);
					strong.appendChild(svg);

					this.svgElements.push({ svg, path, strong });
				});
			}

			setupScrollObserver() {
				const options = {
					root: null,
					rootMargin: "-20px",
					threshold: 0.8,
				};

				this.observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						const strong = entry.target;
						const svgData = this.svgElements.find(
							(item) => item.strong === strong
						);

						if (svgData) {
							if (entry.isIntersecting) {
								this.animateHandDrawnCircle(svgData, true);
							} else {
								this.animateHandDrawnCircle(svgData, false);
							}
						}
					});
				}, options);

				this.strongs.forEach((strong) => {
					this.observer.observe(strong);
				});
			}

			generateHandDrawnPath(width, height) {
				const padding = 10;
				const w = width + padding * 2;
				const h = height + padding * 2;

				const originalWidth = 218;
				const originalHeight = 90;

				const scaleX = w / originalWidth;
				const scaleY = h / originalHeight;

				const originalPath =
					"M3 81.0964C4 65.4297 19.1 29.8964 71.5 13.0964C137 -7.90363 224.873 3.41737 214 40.5964C203.5 76.5 115.886 83.4753 87 86.0964C55 89 17.5212 90 23 62.0964C26.927 42.0964 44.6362 34.0964 53 32.5964";

				const transformPath = (pathStr) => {
					return pathStr.replace(/([0-9.-]+)\s+([0-9.-]+)/g, (match, x, y) => {
						const newX = parseFloat(x) * scaleX;
						const newY = parseFloat(y) * scaleY;
						return `${newX} ${newY}`;
					});
				};

				return transformPath(originalPath);
			}

			animateHandDrawnCircle(svgData, isVisible) {
				const { svg, path, strong } = svgData;

				if (isVisible) {
					const rect = strong.getBoundingClientRect();
					const width = rect.width;
					const height = rect.height;

					const pathData = this.generateHandDrawnPath(width, height);

					const svgWidth = width + 20;
					const svgHeight = height + 20;

					svg.setAttribute("width", svgWidth);
					svg.setAttribute("height", svgHeight);
					svg.setAttribute("viewBox", `0 0 ${svgWidth} ${svgHeight}`);

					path.setAttribute("d", pathData);

					requestAnimationFrame(() => {
						path.setAttribute("stroke-dasharray", "1 0");
					});
				} else {
					path.setAttribute("stroke-dasharray", "0 1");
				}
			}

			disconnectedCallback() {
				if (this.observer) {
					this.observer.disconnect();
				}
			}
		}
	);
}
